<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="类型">
              <a-select v-model="queryParam.type_id"  placeholder="请选择"
              allowClear >
      <a-select-option v-for="(option,index) in [{'name':'一级培训班','id':1},{'name':'二级培训班','id':2},{'name':'送陪',id:3}]" :value="option.id">{{option.name}}</a-select-option>
    </a-select>
            </a-form-item>
          </a-col>


          <a-col :md="10" :sm="24">
            <a-form-item label="申报日期">
              <a-range-picker
                  v-model="queryParam.time_range_moment"
                  style="width: 100%"
                  format="YYYY-MM-DD"
                  :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>



           </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >
      <!--<a-button type="primary" icon="plus" @click="addHandle" >新建</a-button>-->
      <!-- <a-button type="primary" icon="plus"   @click="addHandle" >申请办培训</a-button> -->


    <div class="table-operator">
      <a-button @click="download(1)">
        导出
        <a-icon type="download" />
      </a-button>
    </div>

    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            申请人{{record.name}} {{record.phone}}
            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            申请时间 {{record.create_time|timeFormat}}
            <br/>
            培训时间 {{record.time_start}} - {{record.time_end}}
          </div>
      </span>
      <span slot="status" slot-scope="text,record">


        <a-tag v-if="record.status==2" color="green">审核通过</a-tag>
        <a-tag v-else-if="record.status==3" color="red">审核失败</a-tag>
        <a-tag v-else>待审核</a-tag>
        <br/>
<!--        <a-tag  v-if="record.status==2">审核通过,请进行项目配置</a-tag>-->

      </span>
      <span slot="action" slot-scope="text,record,index">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDocument(record)" >协议管理</a>
          <br/>
          <a @click="handleGoods(record)" >物料订购</a>
          <a-divider type="vertical" />
          <a @click="handleOrderEdit(record)">缴费信息</a>
          <a-divider type="vertical" />

            <a-popconfirm
                    v-show="record.status==3||record.status==1"
                    title="确定删除吗"
                    @confirm="onDelete(record,index)"
                    okText="确定"
                    cancelText="取消"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
        </template>
      </span>
    </s-table>

    <a-modal
            title="申请办培训"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申请培训类型"
                      hasFeedback
              >
                <a-select v-model="formData.type_id"  placeholder="请选择"
                          allowClear >
                  <a-select-option v-for="(option,index) in  typeOptions" :value="option.id">{{option.name}}</a-select-option>
                </a-select>
              </a-form-item>

            </a-col>
            <a-col :md="12" :sm="24">

            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="培训联系人"
                      hasFeedback
              >
                <a-input   v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入培训联系人' }]}
            ]"
                         placeholder="请输入培训联系人"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="联系电话"
                      hasFeedback
              >
                <a-input    v-decorator="[
              'phone',
              {rules: [{ required: true, message: '请输入联系电话' }]}
            ]"
                         placeholder="请输入联系电话"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申请单位"
                      hasFeedback
              >
                <a-input   v-decorator="[
              'danwei',
              {rules: [{ required: true, message: '请输入申请单位' }]}
            ]"
                         placeholder="请输入申请单位"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="微信号"
                      hasFeedback
              >
                <a-input    v-decorator="[
              'weixin',
              {rules: [{ required: true, message: '请输入微信号' }]}
            ]"
                         placeholder="请输入微信号"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="所在地区"
                      hasFeedback
              >
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.areas" changeOnSelect />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="地址"
                      hasFeedback
              >
                <a-input    v-decorator="[
              'address',
              {rules: [{ required: true, message: '请输入地址' }]}
            ]"
                            placeholder="请输入地址"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="拟定培训时间"
                      hasFeedback
              >
                <a-range-picker
                        v-model="formData.time_range_moment"
                        :showTime="{
      }"
                        format="YYYY-MM-DD"
                />
              </a-form-item>
            </a-col>

              <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="预计人数"
                        hasFeedback
                >
                  <a-input    v-decorator="[
              'member',
              {rules: [{ required: true, message: '请输入预计人数' }]}
            ]"
                              placeholder="请输入预计人数"/>
                </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="快递单号"
                  hasFeedback
              >
                <a-input    v-decorator="[
              'express_num',
              {rules: []}
            ]"
                            placeholder="请输入快递单号"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="状态"
                        hasFeedback
                >
                    <a-radio-group v-model="formData.status" button-style="solid">
                        <a-radio-button :value="1">
                            待审核
                        </a-radio-button>
                        <a-radio-button :value="2">
                            审核通过
                        </a-radio-button>
                        <a-radio-button :value="3">
                            审核失败
                        </a-radio-button>
                    </a-radio-group>
                </a-form-item>
            </a-col>
        </a-row>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="进度状态"
                  hasFeedback
              >
                <a-radio-group v-model="formData.jindu_status" button-style="solid">
                  <a-radio-button :value="1">
                    培训申请
                  </a-radio-button>
                  <a-radio-button :value="2">
                    报名通道开启
                  </a-radio-button>
                  <a-radio-button :value="3">
                    资料订购
                  </a-radio-button>
                  <a-radio-button :value="4">
                    成绩上传
                  </a-radio-button>
                  <a-radio-button :value="5">
                    结算完成
                  </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="visible=false">取消</a-button>
        <a-button key="forward" :loading="saveLoading"  type="primary" @click="handleOk">提交</a-button>
      </template>
    </a-modal>


    <a-modal
            title="相关协议操作"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="xieyiVisible"
            @ok="xieyiVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

          <a-table :columns="documentColumns" :dataSource="documentList" :pagination="false" rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="file" slot-scope="name,record">
              <p v-for="(file,findex) in record.files" :key="findex">
                <a  @click="downloadXieyi(file)">{{file.name}}</a>

              </p>
              <em v-if="record.note" >({{record.note}})</em>
            </div>
            <template slot="user_name" slot-scope="text,record,index">
              <a-tag v-if="record.user_type==2" color="red">
                CCA
              </a-tag>
              <a-tag v-else color="blue">
                省市
              </a-tag>
              {{record.user_name}}
            </template>

            <template slot="footer" slot-scope="currentPageData">
              <file-uploader
                      style="width: 200px; margin-right: 10px; float: left"
                      :file-list="fileFormData.files"
                      :numberLimit="5"
              />
              <a-input
                      style="width: 200px; margin-right: 10px; float: left"
                      v-model="fileFormData.note"
                      placeholder="请输入备注信息"/>
              <a-button icon="plus" @click="addFile" >新增</a-button>
            </template>
          </a-table>
        </a-form>
      </a-spin>

    </a-modal>


    <a-modal
            title="物料订购"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="goodsVisible"
            @ok="goodsVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

          <a-table v-if="goodsList.list.length>0" :columns="goodsColumns" :dataSource="goodsList.list" :pagination="false" rowKey="id" :scroll="{ y: 300 }" bordered :defaultExpandAllRows="true">
            <div slot="price" slot-scope="name,record">
              <div v-show="record.count>0">
                数量:{{record.count}}<br/>
                小记:{{record.total_price}}
              </div>
            </div>
            <div slot="title1" slot-scope="name,record">
              <p style="font-weight: bold;">{{record.title}}</p>
              <img style="width: 60px;" :src="record.pic_url" />
              {{record.desc}}
            </div>

            <a-table
              slot="expandedRowRender"
              slot-scope="record2"
              :columns="goodsItemsColumns"
              :data-source="record2.items"
              :pagination="false"
            >
            <div slot="title2" slot-scope="name,record">
              {{record.title}}<br/>
              {{record.price}}/{{record.unit}}
            </div>
            <div slot="count" slot-scope="name,record">
              <!-- {{name}}{{record}} -->
              <a-input-number v-model="record.count" :min="0" @change="onCountChange"  /><br/>
              <em v-if="record.total_price>0" >{{record.total_price}}元</em>
            </div>
            </a-table>

          </a-table>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="goodsVisible=false">取消</a-button>
        <a-button key="forward" :loading="saveLoading"  type="primary" @click="handleGoodsOk">确定</a-button>
      </template>
    </a-modal>
 


  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import RSwitch from '@/components/RSwitch/'
  import areaOptions from '@/utils/area'
  import setting from '@/config/setting'
  import moment from 'moment'
  import qs from 'qs'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getSaiquApplyList ,getSaiquApplyDetail,editSaiquApply,addSaiquApply,getSaijiList ,getTypeOptions,addXieyiFile,getXieyiList,saiquApplyStep2Detail,saiquApplyDelete,saiquApplyStep2Save,editSaiquApplyOrder,getSaiquApplyOrderDetail } from '@/api/huiyi'
  export default {
    name: 'SaiquApplyList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      RSwitch,
      EditableCell,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        xieyiVisible: false,
        goodsVisible: false,
        saveLoading:false,
        typeOptions:[],
        formData:{
          id:0,
          status:1,
          is_online:2,
          zban:'国家体育总局体操运动管理中心\n',
          cban:'全国啦啦操\n',
          photo_service:1,
          type:1,
          danwei:'',
          saidate_moment:[],
          saidate:[],
          time_range_moment:[],
          time_range:[],
          erweiimg:[],
          areas:[],
          pic:[],
          pics:[],
          express_num: '',
          jindu_status: 1,
        },
        saijiOptions:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
          time_range_moment:[],
          time_range:[]
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '名称',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '状态',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 300,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;


        if (that.queryParam.time_range_moment.length==2) {
          that.queryParam.time_range = [
          that.queryParam.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
          that.queryParam.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          that.queryParam.time_range = []
        }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getSaiquApplyList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        },

        fileFormData:{
          apply_id:undefined,
          note:undefined,
          files: []
        },
        //人员管理表头
        documentColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '文件',
            dataIndex: 'title',
            scopedSlots: { customRender: 'file' },
          },
          {
            title: '上传人',
            dataIndex: 'user_name',
            width:'150px',
            scopedSlots: { customRender: 'user_name' },
          },
           {
           title: '上传时间',
           width:'150px',
             dataIndex: 'create_time',
             customRender: (text) =>  {
               return moment(text*1000).format('YYYY-MM-DD HH:mm');
             }
           },
        ],
        documentList:[],
        documentKeywords: '',

        goodsColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '名称',
            dataIndex: 'title',
            scopedSlots: { customRender: 'title1' },
          },
          {
            title: '小记',
            dataIndex: 'price',
            width:'200px',
            scopedSlots: { customRender: 'price' },
          },
        ],
        goodsItemsColumns:[
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '名称',
            dataIndex: 'title',
            scopedSlots: { customRender: 'title2' },
          },
          {
            title: '数量',
            dataIndex: 'count',
            width:'200px',
            scopedSlots: { customRender: 'count' },
          },
        ],
        goodsList:{
          list:[]
        },
        goodsFormData:{
          apply_id:undefined,
        },
        orderVisible: false,
        orderFormData:{
          pics:[]
        },
      }
    },
    computed:{
        total_count(){
            let count = 0;
            this.goodsList.list.map(goods =>{
                count +=goods.count
            });
            return count;
        }
    },
    created(){
    },

    mounted(){
      let that = this;
    },
    methods: {
      moment,

      addHandle(){
        this.formData = {
          id:0,
          status:1,
          is_online:2,
          zban:'国家体育总局体操运动管理中心\n',
          cban:'全国啦啦操\n',
          photo_service:1,
          type:1,
          danwei:'',
          saidate_moment:[],
          saidate:[],
          time_range_moment:[],
          time_range:[],
          erweiimg:[],
          areas:[],
          pic:[],
          pics:[],
          express_num: '',
          jindu_status: 1,
        },
        this.form.resetFields();
        this.visible = true
      },
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getSaiquApplyDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            if(res.data.area){
              res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            }else{
              res.data.areas = [];
            }
            self.typeOptions = res.data.type_options;
            res.data.time_range_moment = [moment(res.data.time_start,'YYYY-MM-DD'),moment(res.data.time_end,'YYYY-MM-DD')];
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

    download(type) {
      console.log("this.queryParam");
      console.log(this.queryParam); 
      let queryParam = {}
      for(let i in this.queryParam){
        if(i != 'time_range_moment'){
          queryParam[i] = this.queryParam[i]
        }
      }
      console.log(queryParam);
      switch (type) {
        case 1:
          window.open(
            setting.apiBaseURL +
              "/adminapi/huiyi/saiquApplyDownload?" +
              qs.stringify(queryParam)
          );
          break;
      }
    },
      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        if(self.formData.time_range_moment.length!=2){
          self.$message.error('请选择时间范围');
          return ;
        }
        if(!self.formData.type_id){
          self.$message.error('请选择类型');
          return ;
        }
        if(!self.formData.mode){
          // self.$message.error('请选择赛事模式');
          // return ;
        }
        if(self.formData.areas.length!=3){
          self.$message.error('请选择完整地区');
          return ;
        }
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            if(self.formData.id>0){

                editSaiquApply({
                  id:self.formData.id,
                  name:values.name,
                  phone:values.phone,
                  danwei:values.danwei,
                  weixin:values.weixin,
                  area:self.formData.areas[self.formData.areas.length-1],
                  address:values.address,
                  type_id:self.formData.type_id,
                  member:values.member,
                  express_num:values.express_num,
                  status:self.formData.status,
                  jindu_status:self.formData.jindu_status,
                  time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD'),self.formData.time_range_moment[1].format('YYYY-MM-DD')],
                }).then(res => {
                  self.$message.success('修改成功')
                  self.$refs.table.refresh(false)
                  self.visible = false;
                  self.saveLoading = false;
              }).catch(err =>{
                  self.$message.error(err.data.msg);
                  self.saveLoading = false;
              })
            }else{
            }

          }
        })
      },


      handleDocument(record) {
        let self = this
        self.fileFormData.apply_id = record.id;
        self.getDocumentList();

        this.xieyiVisible = true
      },

      getDocumentList(){
        let self = this
        getXieyiList({apply_id: self.fileFormData.apply_id}).then(res => {
          self.documentList = res.data
        })
      },

      handleGoods(record) {
        let self = this
        self.goodsFormData.apply_id = record.id;
        self.saiquApplyStep2Detail();

        this.goodsVisible = true
      },

      saiquApplyStep2Detail(){
        let self = this
        saiquApplyStep2Detail({apply_id: self.goodsFormData.apply_id}).then(res => {
          self.goodsList = res.data
        })
      },

      onDelete(record){
        let self = this;
        saiquApplyDelete({
          id:record.id
        }).then(res => {
          self.$refs.table.refresh()
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })

      },
      addFile(){
        let self = this;
        if(self.fileFormData.files.length==0){
          self.$message.error('请上传文件');
          return ;
        }
        addXieyiFile(self.fileFormData).then(res => {
          self.getDocumentList();
          self.fileFormData.files = [];
          self.$message.success('新增成功')
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
      },
      downloadXieyi(file){
        let self = this;
        window.open(setting.apiBaseURL+'/api/index/dlf?name='+file.name+'&url='+encodeURIComponent(file.url));
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

      onCountChange(value){
          console.log(value);
          let list = this.goodsList.list;
          console.log(list);

          list.map((goods,index) => {
              goods.count = 0;
              goods.total_price = 0;
              goods.items.map((item,iindex) =>{
                  item.total_price = item.count * item.price;
                  goods.count += item.count;
                  goods.total_price += item.total_price;
              });
          });
      },

      // 增改 处理
      handleGoodsOk(e) {
        let self = this;
        self.saveLoading = true;
        saiquApplyStep2Save({
          id:self.goodsFormData.apply_id,
          list:self.goodsList.list
        }).then(res => {
          self.$message.success('修改成功')
          self.$refs.table.refresh()
          self.goodsVisible = false;
          self.saveLoading = false;
        }).catch(err =>{
            self.$message.error(err.data.msg);
          self.saveLoading = false;
        })
      },

      handleOrderEdit(record){
        let self = this
        getSaiquApplyOrderDetail({ baoming_id: record.id }).then(res => {
          self.orderVisible = true
          setTimeout(() =>{
            self.orderFormData.id = record.id;
            console.log('handleEdit')

            self.orderFormData = { ...res.data };
          },200)
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
        // console.log(this.mdl)
      },

      // 增改 处理
      handleOrderOk(e) {
        let self = this;
        e.preventDefault();

        self.saveLoading = true;
        editSaiquApplyOrder({
          id:self.orderFormData.id,
          baoming_id:self.orderFormData.baoming_id,
          status:self.orderFormData.status,
          adminnote:self.orderFormData.adminnote,
          memberprice:self.orderFormData.memberprice,
          pay_price:self.orderFormData.pay_price,
          pics:self.orderFormData.pics,
        }).then(res => {
          self.$message.success('修改成功')
          self.$refs.table.refresh()
          self.orderVisible = false;
          self.saveLoading = false;
        }).catch(err =>{
          self.$message.error(err.data.msg);
          self.saveLoading = false;
        })
      },
    },
    filters:{
    },
    watch: {
    },
  }
</script>
